import { FilterModel } from "src/common/models/search";

export class SearchCache {

	public static instance: SearchCache = new SearchCache();

	public static Filters: FilterModel[];

	public static hash(value: any): any {
		let val = JSON.stringify(value);
        var hash = 0, i, chr;
        if (val.length === 0) return hash;
        for (i = 0; i < val.length; i++) {
          chr   = val.charCodeAt(i);
          hash  = ((hash << 5) - hash) + chr;
          hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }

	public static store(key: string, val: any) {
		sessionStorage.setItem(key, JSON.stringify(val));
	}

	public static get(key: string): any {
		let valString = sessionStorage.getItem(key);
		return valString != undefined ? JSON.parse(valString) : undefined;
	}

  public static removeItem(key: string) {
    sessionStorage.removeItem(key);
  }

  public static clear() {
    sessionStorage.clear();
  }
}
